<div class="relative text-platform flex justify-center overflow-y-auto">
  <div class="page-container">
    <div class="h-32 lg:h-40"></div>
    <div class="font-bold text-4xl lg:text-5xl mb-10">Ablauf</div>
    <div class="lg:text-xl font-light">
      <div class="mb-10">
        <div class="font-semibold">3. Dezember, mittags:</div>
        <div class="leading-snug mb-6">Freischaltung der Registrierung und Anlegen von Gruppen auf der Webseite</div>
        <div class="font-semibold">4. Dezember 00:01 Uhr:</div>
        <div class="leading-snug mb-6">
          Bekanntgabe der Verkaufsorte über Instagram und auf dieser Website, das Anstellen beginnt
        </div>
        <div class="font-semibold">00:30 Uhr:</div>

        <div class="leading-snug mb-6">
          Gleichzeitige Schließung aller Schlangen. Wer jetzt in der Schlange steht, wird in den Lostopf aufgenommen.
          Wir müssen jede Gruppe abscannen und bitten um Geduld!
        </div>
        <div class="font-semibold">01:30 Uhr:</div>
        <div class="leading-snug mb-12">Losung & Bekanntgabe der Ergebnisse, im Anschluss Verkauf der Karten</div>
      </div>
    </div>
  </div>
</div>
